// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floorplan-planned-adventures-title {
  font-family: var(--font-heading);
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-secondary);
  margin-bottom: 12px;
  text-align: center;
}

.ttbFloorPlanTextLabel {
  font-family: var(--font-heading);
  font-size: 13px;
  fill: var(--color-wood-700);
}

.ttbFloorPlanTextLabelStrong {
  font-size: 15px;
  font-weight: 700;
}

.ttbCourtyardEventTitle {
  font-family: var(--font-body);
  font-weight: 500;
  fill: var(--color-wood-700);
  letter-spacing: 0;
}

.ttbVipLayoutSwitch {
  cursor: pointer;
  outline: none;
}

.ttbVipLayoutSwitch:focus {
  outline: none;
}

.ttbVipLayoutSwitch:focus-visible {
  outline: none;
}

.ttbVipLayoutSwitch rect {
  fill: rgba(245, 239, 231, 0.9);
  stroke: var(--color-wood-600);
  stroke-width: 3;
}

.ttbVipLayoutSwitchActive rect {
  fill: rgba(245, 239, 231, 0.9);
  stroke: var(--color-wood-600);
}

.ttbVipLayoutSwitchDisabled {
  cursor: not-allowed;
}

.ttbVipLayoutSwitchDisabled rect {
  opacity: 0.55;
}

.ttbVipLayoutSwitchText {
  font-family: var(--font-heading);
  font-size: 16px;
  font-weight: 900;
  stroke: var(--color-wood-700);
  stroke-width: 0.45px;
  letter-spacing: -0.5px;
  fill: var(--color-wood-700);
  pointer-events: none;
  user-select: none;
}

@media (max-width: 425px) {
  .floorplan-planned-adventures-title {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .ttbFloorPlanTextLabel {
    font-size: 12px;
  }

  .ttbFloorPlanTextLabelStrong {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/floorPlan/FloorPlanMap.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".floorplan-planned-adventures-title {\n  font-family: var(--font-heading);\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  margin-bottom: 12px;\n  text-align: center;\n}\n\n.ttbFloorPlanTextLabel {\n  font-family: var(--font-heading);\n  font-size: 13px;\n  fill: var(--color-wood-700);\n}\n\n.ttbFloorPlanTextLabelStrong {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.ttbCourtyardEventTitle {\n  font-family: var(--font-body);\n  font-weight: 500;\n  fill: var(--color-wood-700);\n  letter-spacing: 0;\n}\n\n.ttbVipLayoutSwitch {\n  cursor: pointer;\n  outline: none;\n}\n\n.ttbVipLayoutSwitch:focus {\n  outline: none;\n}\n\n.ttbVipLayoutSwitch:focus-visible {\n  outline: none;\n}\n\n.ttbVipLayoutSwitch rect {\n  fill: rgba(245, 239, 231, 0.9);\n  stroke: var(--color-wood-600);\n  stroke-width: 3;\n}\n\n.ttbVipLayoutSwitchActive rect {\n  fill: rgba(245, 239, 231, 0.9);\n  stroke: var(--color-wood-600);\n}\n\n.ttbVipLayoutSwitchDisabled {\n  cursor: not-allowed;\n}\n\n.ttbVipLayoutSwitchDisabled rect {\n  opacity: 0.55;\n}\n\n.ttbVipLayoutSwitchText {\n  font-family: var(--font-heading);\n  font-size: 16px;\n  font-weight: 900;\n  stroke: var(--color-wood-700);\n  stroke-width: 0.45px;\n  letter-spacing: -0.5px;\n  fill: var(--color-wood-700);\n  pointer-events: none;\n  user-select: none;\n}\n\n@media (max-width: 425px) {\n  .floorplan-planned-adventures-title {\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n\n  .ttbFloorPlanTextLabel {\n    font-size: 12px;\n  }\n\n  .ttbFloorPlanTextLabelStrong {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
